import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const LoadingContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #d0fbff, #83ffe3, #b0ff64, #d395ff, #ff7fd9);
  background-size: 400% 400%;
  animation: gradientBG 10s ease infinite;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  @keyframes gradientBG {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

const CandyWrapper = styled.div`
  text-align: center;
`;

const Logo = styled(motion.img)`
  width: 200px;
  height: auto;
  margin-bottom: 2rem;
  filter: drop-shadow(0 20px 30px rgba(0,0,0,0.2));
  
  @media (max-width: 768px) {
    width: 150px;
  }
`;

const CandyLoader = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
`;

const Candy = styled(motion.div)`
  width: 60px;
  height: 60px;
  border-radius: ${props => props.shape === 'square' ? '20px' : '50%'};
  background: ${props => props.color};
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
  transform-origin: center;
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const LoadingText = styled(motion.p)`
  color: white;
  font-size: 1.2rem;
  margin-top: 2rem;
  font-family: 'Comic Neue', cursive;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
`;

const LoadingScreen = ({ onLoadingComplete }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
      onLoadingComplete();
    }, 2500);
  }, [onLoadingComplete]);

  const candies = [
    { color: '#d0fbff', shape: 'circle', delay: 0 },
    { color: '#83ffe3', shape: 'square', delay: 0.2 },
    { color: '#b0ff64', shape: 'circle', delay: 0.4 },
    { color: '#d395ff', shape: 'square', delay: 0.6 },
    { color: '#ff7fd9', shape: 'circle', delay: 0.8 },
  ];

  if (!isLoading) return null;

  return (
    <LoadingContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <CandyWrapper>
        <Logo
          src="/assets/kemlo-logo.png"
          alt="Kemlo"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, type: "spring" }}
        />
        
        <CandyLoader>
          {candies.map((candy, index) => (
            <Candy
              key={index}
              color={candy.color}
              shape={candy.shape}
              initial={{ y: 0 }}
              animate={{
                y: [-30, 30, -30],
                rotate: candy.shape === 'circle' ? [0, 360] : [0, 90, 180, 270, 360],
                scale: [1, 1.2, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                delay: candy.delay,
                ease: "easeInOut"
              }}
            />
          ))}
        </CandyLoader>
        
        <LoadingText
          animate={{
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
          }}
        >
          Loading sweet treats...
        </LoadingText>
      </CandyWrapper>
    </LoadingContainer>
  );
};

export default LoadingScreen;